"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Columnlist = ({ columns = 2, elements }) => {
    const columnClass = 'column-list-' + columns;
    return (React.createElement("ul", { className: columnClass + ' vf-clear-ul' }, elements));
};
exports.default = Columnlist;
